exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-modal {\n  padding-left: 0 !important;\n}\n\n.full-modal.modal.fade:not(.in) .modal-dialog {\n  -webkit-transform: translate3d(0, 100%, 0);\n  transform: translate3d(0, 100%, 0);\n}\n\n.full-modal .modal-lg.modal-dialog {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n}\n\n.full-modal .modal-content {\n  width: 100%;\n  height: 100%;\n  box-shadow: none;\n  border: none;\n  border-radius: 0;\n  overflow: auto;\n}\n\n.full-modal .modal-content .modal-body {\n  max-height: 100%;\n  position: static;\n}\n\n.consistentBackdrop {\n  z-index: 1050;\n}\n", ""]);

// exports
